<style lang="scss">
  
</style>
<template>
  <Confirmalert
    :persistent="true"
    :isShow="showOffLineAlert"
    :content='off_line_config.error_text'
    confirmText="去登录"
    cancelText="取消"
    :onConfirm="onConfirm"
    :onCancel="onCancel"
  />
</template>
<script>
import Confirmalert from "@c/Confirmalert";
export default {
  components: {Confirmalert},
  data: () => ({
  }),
  computed: {
    showOffLineAlert() {
      return this.$store.state.user.showOffLineAlert
    },
    showOffLineAlert() {
      return this.$store.state.user.showOffLineAlert
    },
    off_line_config() {
      return this.$store.getters['app/off_line_config']
    }
  },
  methods: {
    onConfirm() {
      console.log(1)
      this.$store.commit('user/setShowOffLineAlert', false)
      this.$router.push({
        path: "/login",
      });
    },
    onCancel() {
      this.$store.commit('user/setShowOffLineAlert', false)
    }
  },
  created() {
    this.$store.commit('user/setShowOffLineAlert', false)
  }
}
</script>